module.exports = __webpack_public_path__ + "img/Mikae_on_klusteri_tummalle_taustalle_EN.b401a7f1.svg";